import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// --- Firebase Configuration ---
const firebaseConfig = {
  apiKey: "AIzaSyBhX2IxcF0ZQralv4iNX9vChuNivMOAP20",
  authDomain: "fiwara.com",
  projectId: "investment-tracker-43a11",
  storageBucket: "investment-tracker-43a11.appspot.com",
  messagingSenderId: "190550976752",
  appId: "1:190550976752:web:8fd5a5f990c379c99f3a35"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// Callable functions live in europe-west1 (see functions/index.js); the region
// must match or httpsCallable resolves the wrong URL.
const functions = getFunctions(app, 'europe-west1');
const googleProvider = new GoogleAuthProvider();
const appId = 'default-portfolio-app-cz';

export { auth, db, functions, googleProvider, appId };